import { Injectable } from '@angular/core';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';
import {
  ProcessorName,
  ACHProcessorName,
  GatewayName,
  MerchantAccountStatus,
  ProcessorType,
  ContactType,
  IntegrationName,
} from '../constants';
import { GatewayAPIService } from '../gateway-api.service';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  static STATES_KEY: string = 'STATES';
  static COUNTRIES_KEY: string = 'COUNTRIES';

  options = { authenticate: true, setRoot: true };

  constructor(private api: GatewayAPIService) {}

  // TODO: pull from API
  static ccProcessorList: ListItem[] = [
    new ListItem({ id: ProcessorName.Fiserv, name: ProcessorName.Fiserv }),
    new ListItem({ id: ProcessorName.Paya, name: ProcessorName.Paya }),
    new ListItem({ id: ProcessorName.Elavon, name: ProcessorName.Elavon }),
    new ListItem({ id: ProcessorName.NMI, name: ProcessorName.NMI }),
    new ListItem({ id: ProcessorName.Converge, name: ProcessorName.Converge }),
    new ListItem({ id: ProcessorName.ProPay, name: ProcessorName.ProPay }),
    new ListItem({ id: ProcessorName.TSYS, name: ProcessorName.TSYS }),
    new ListItem({ id: ProcessorName.Worldpay, name: ProcessorName.Worldpay }),
  ];

  // TODO: pull from API
  static achProcessorList: ListItem[] = [
    new ListItem({
      id: ACHProcessorName.AuthNetECheck,
      name: ACHProcessorName.AuthNetECheck,
    }),
    new ListItem({
      id: ACHProcessorName.JackHenry,
      name: ACHProcessorName.JackHenry,
    }),
    new ListItem({
      id: ACHProcessorName.NMIECheck,
      name: ACHProcessorName.NMIECheck,
    }),
    new ListItem({
      id: ACHProcessorName.PayaDirect,
      name: ACHProcessorName.PayaDirect,
    }),
  ];

  // TODO: pull from API
  static gatewayList: ListItem[] = [
    new ListItem({ id: GatewayName.Swipesum, name: GatewayName.Swipesum }),
    // new ListItem({id: GatewayName.Swipesum, name: GatewayName.Swipesum}),
    //new ListItem({id: GatewayName.Mastercard, name: GatewayName.Mastercard}),
    // new ListItem({id: GatewayName.AuthNet, name: GatewayName.AuthNet}),
    // new ListItem({id: GatewayName.Converge, name: GatewayName.Converge}),
    // new ListItem({id: GatewayName.NMI, name: GatewayName.NMI}),
  ];

  static integrationList: ListItem[] = [
    new ListItem({ id: IntegrationName.Campfire, name: IntegrationName.Campfire }),
    new ListItem({ id: IntegrationName.FridayLunch, name: IntegrationName.FridayLunch }),
  ];

  // TODO: pull from API
  static brandList: ListItem[] = [
    new ListItem({ id: 'New Brand', name: 'New Brand' }),
    new ListItem({ id: 'Dryer Vent Wizard', name: 'Dryer Vent Wizard' }),
    new ListItem({ id: 'Glass Doctor', name: 'Glass Doctor' }),
    new ListItem({ id: 'Junk Kings', name: 'Junk Kings' }),
    new ListItem({ id: 'FastSigns', name: 'FastSigns' }),
    new ListItem({ id: 'MY SALON Suite', name: 'MY SALON Suite' }),
    new ListItem({ id: 'N/A', name: 'N/A' }),
    new ListItem({ id: 'testing', name: 'testing' }),
  ];

  static businessTypesList: ListItem[] = [
    new ListItem({ id: 'LLC', name: 'LLC' }),
    new ListItem({ id: 'Sole Proprietor', name: 'Sole Proprietor' }),
    new ListItem({ id: 'C Corp', name: 'C Corp' }),
    new ListItem({ id: 'S Corp', name: 'S Corp' }),
    new ListItem({ id: 'Non-Profit 501c3', name: 'Non-Profit 501c3' }),
    new ListItem({ id: 'Partnership', name: 'Partnership' }),
    new ListItem({ id: 'Government', name: 'Government' }),
    new ListItem({
      id: 'Estate/Trust/Association',
      name: 'Estate/Trust/Association',
    }),
  ];

  static contactTypesList: ListItem[] = [
    new ListItem({ id: ContactType.Primary, name: 'Primary' }),
    new ListItem({ id: ContactType.Principle, name: 'Principle Owner' }),
    new ListItem({ id: ContactType.PCI, name: 'PCI Compliance' }),
    new ListItem({ id: ContactType.Accounting, name: 'Accounting' }),
    new ListItem({ id: ContactType.Technical, name: 'Technical' }),
  ];

  static processingTypeList: ListItem[] = [
    new ListItem({ id: ProcessorType.Card, name: ProcessorType.Card }),
    new ListItem({ id: ProcessorType.ACH, name: ProcessorType.ACH }),
  ];

  static roleList: ListItem[] = [
    new ListItem({
      fk: undefined,
      displayOrder: 0,
      id: 'portal.sales',
      name: 'Sales',
    }),
    new ListItem({
      fk: undefined,
      displayOrder: 0,
      id: 'portal.support',
      name: 'Success',
    }),
    new ListItem({
      fk: undefined,
      displayOrder: 0,
      id: 'portal.manager',
      name: 'Manager',
    }),
    new ListItem({
      fk: undefined,
      displayOrder: 0,
      id: 'portal.merchant',
      name: 'MID Owner',
    }),
    new ListItem({
      fk: undefined,
      displayOrder: 0,
      id: 'portal.admin',
      name: 'Site Administrator',
    }),
  ];

  static addressTypesList: ListItem[] = [
    new ListItem({ id: 'Legal Address', name: 'Legal Address' }),
    new ListItem({ id: 'Mailing Address', name: 'Mailing Address' }),
    new ListItem({ id: 'DBA Address', name: 'DBA Address' }),
  ];

  static cardAcceptanceTypesList: ListItem[] = [
    new ListItem({ id: 'Card Present 100%', name: 'Card Present 100%' }),
    new ListItem({
      id: 'Card Not Present 100%',
      name: 'Card Not Present 100%',
    }),
    new ListItem({ id: 'Internet', name: 'Internet' }),
    new ListItem({ id: 'OMNI Commerce', name: 'OMNI Commerce' }),
  ];

  static bankAccountTypesList: ListItem[] = [
    new ListItem({ id: 'Checking', name: 'Checking' }),
    new ListItem({ id: 'Savings', name: 'Savings' }),
  ];

  static bankHolderTypesList: ListItem[] = [
    new ListItem({ id: 'Business', name: 'Business' }),
    new ListItem({ id: 'Personal', name: 'Personal' }),
  ];

  static timeZoneList: ListItem[] = [
    new ListItem({ id: 'CST', name: 'Central' }),
    new ListItem({ id: 'EST', name: 'Eastern' }),
    new ListItem({ id: 'MST', name: 'Mountain' }),
    new ListItem({ id: 'PST', name: 'Pacific' }),
  ];

  static accountStatusList: ListItem[] = [
    new ListItem({
      name: MerchantAccountStatus.Disabled,
      id: MerchantAccountStatus.Disabled,
    }),
    new ListItem({
      name: MerchantAccountStatus.Test,
      id: MerchantAccountStatus.Test,
    }),
    new ListItem({
      name: MerchantAccountStatus.Live,
      id: MerchantAccountStatus.Live,
    }),
    new ListItem({
      name: MerchantAccountStatus.Retired,
      id: MerchantAccountStatus.Retired,
    }),
  ];

  public async getCountriesList(): Promise<ListItem[]> {
    let list = localStorage.getItem(CacheService.COUNTRIES_KEY);
    if (!list) {
      return await this.getListData('countries', {}).then((l) => {
        localStorage.setItem(CacheService.COUNTRIES_KEY, JSON.stringify(l));
        return l;
      });
    } else {
      return JSON.parse(list) as ListItem[];
    }
  }

  public async getStatesList(
    countryCode: string | undefined,
  ): Promise<ListItem[]> {
    //localStorage.removeItem(CacheService.STATES_KEY);

    if (!localStorage.getItem(CacheService.STATES_KEY)) {
      return await this.getListData('states', {}).then((fullList) => {
        localStorage.setItem(CacheService.STATES_KEY, JSON.stringify(fullList));

        if (countryCode) {
          let filteredList = fullList.filter((i) => i.fk == countryCode);
          fullList = filteredList;
        }

        return fullList;
      });
    } else {
      let sFullList = localStorage.getItem(CacheService.STATES_KEY);
      let fullList: ListItem[] = [];

      if (sFullList) {
        fullList = JSON.parse(sFullList);

        if (countryCode) {
          let filteredList = fullList.filter((i) => i.fk == countryCode);
          fullList = filteredList;
        }
      }
      return fullList;
    }
  }

  private getListData(endpoint: string, data: any): Promise<ListItem[]> {
    return this.api.apiCallSane(
      '/cache/' + endpoint,
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }
}
